/* eslint-disable react-hooks/exhaustive-deps */
import BodyCotizador from 'components/HomeMex/BodyCotizador';
import useParametrosSeccion from 'components/HomeMex/useParametrosSeccion';
import useQueryParams from 'hooks/useQueryParams';
import useUsuario from 'hooks/useUsuario';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { loginAsSuscriptor, logoutAsSuscriptor } from 'redux/actions/aLogin';
import Loading from 'wrappers/Loading';

const ContainerHomeMex = () => {
  const { data, loading, message } = useParametrosSeccion({
    codigoSeccion: 'personas',
  });

  const { user } = useQueryParams();
  const history = useHistory();
  useEffect(() => {
    if (user) {
      history.push(`/login?user=agentes&session=${user}`);
      return history.replace(`/login?user=agentes&session=${user}`);
    }
  }, [user, history]);

  const usuario = useUsuario();
  const dispatch = useDispatch();

  useEffect(() => {
    if (usuario?.sesionSuscriptor) {
      const { sesionSuscriptor } = usuario;
      dispatch(loginAsSuscriptor(sesionSuscriptor));
    } else if (usuario?.isSuscriptor && !usuario.idSuscriptor) {
      dispatch(logoutAsSuscriptor());
    }
  }, []);

  return (
    <React.Fragment>
      <Loading loading={loading} message={message}>
        <BodyCotizador {...data} />
      </Loading>
    </React.Fragment>
  );
};

export default ContainerHomeMex;
